import { filter, map } from 'rxjs/operators';

import { onCompleteAddressActionCreators } from '../../../config/address-lookup.config';
import { RootEpic } from '../../../store/epics';
import { addressResolved } from '../reducers/addressLookup';

export const addressResolvedEpic: RootEpic = (action$, state$) => {
  return action$.pipe(
    filter(addressResolved.match),
    map(() => onCompleteAddressActionCreators[state$.value.addressLookup.type](state$.value)),
  );
};
